import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ExpertiseSection = () => {
  const services = [
    {
      title: 'Awning ACP or Steel',
      image: '/Our_expertise_img/Awning ACPor Steel.PNG',
    },
    {
      title: 'Commercial I beam structure and roofing',
      image: '/Our_expertise_img/Commercial I beam  structure and roofing.PNG',
    },
    {
      title: 'Fencing',
      image: '/Our_expertise_img/Fencing.PNG',
    },
    {
      title: 'Metal Hoarding',
      image: '/Our_expertise_img/Metal Hoarding.PNG',
    },
    {
      title: 'Metal roofing',
      image: '/Our_expertise_img/Metal roofing.PNG',
    },
    {
      title: 'MS or SS Grating',
      image: '/Our_expertise_img/MSor SS Grating.PNG',
    },
    {
      title: 'MS or SS Hand Railing',
      image: '/Our_expertise_img/MS or SS Hand Railing.PNG',
    },
    {
      title: 'Security Gate',
      image: '/Our_expertise_img/Security Gate.PNG',
    },
    {
      title: 'Signboard Frame',
      image: '/Our_expertise_img/Singboard Frame.PNG',
    },
    {
      title: 'Signage Wall',
      image: '/Our_expertise_img/Sigage Wall.PNG',
    },
    {
      title: 'Steel Deck or Staircase',
      image: '/Our_expertise_img/Steel Deck or Staircase.PNG',
    },
    {
      title: 'Warehouse or Site Office',
      image: '/Our_expertise_img/Warehouse or Site Office.PNG',
    },
  ];
  const [activeIndex, setActiveIndex] = useState(0);
  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % services.length);
    }, 3000); // Change slide every 3 seconds
    return () => clearInterval(interval);
  }, [services.length]);

  const [baseCardWidth, setBaseCardWidth] = useState(250); // Default for desktop
  const [baseCardHeight, setBaseCardHeight] = useState(310); // Default for desktop
  const [cardGap, setCardGap] = useState(32); // Default for desktop
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) { // Mobile
        setBaseCardWidth(200);
        setBaseCardHeight(250);
        setCardGap(0); // No gap for single card view
        setIsMobile(true);
      } else if (width >= 640 && width < 1024) { // Tablet
        setBaseCardWidth(220);
        setBaseCardHeight(280);
        setCardGap(24);
        setIsMobile(false);
      } else { // Desktop
        setBaseCardWidth(250);
        setBaseCardHeight(310);
        setCardGap(32);
        setIsMobile(false);
      }
    };

    handleResize(); // Set initial values
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);  const goToNext = () => {
    setActiveIndex((current) => (current + 1) % services.length);
  };

  const goToPrevious = () => {
    setActiveIndex((current) => (current - 1 + services.length) % services.length);
  };

  return (
    <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#364A9A] text-center mb-12 font-poppins">
          OUR EXPERTISE
        </h2>

        <div className="relative flex items-center justify-center min-h-[300px] sm:min-h-[400px] md:min-h-[500px] lg:min-h-[600px] overflow-hidden"> {/* Changed to min-h to ensure h2 visibility and accommodate cards */}
          {/* Scroll Arrows */}
          <button
            onClick={goToPrevious}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full z-20 hover:bg-opacity-75 transition-all duration-300"
          >
            <ChevronLeft size={24} />
          </button>
          <button
            onClick={goToNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full z-20 hover:bg-opacity-75 transition-all duration-300"
          >
            <ChevronRight size={24} />
          </button>

          {/* Expertise Cards Container */}
          <div className="relative w-full flex justify-center items-center">
            {services.map((service, index) => {
              let positionX = 0;
              let opacity = 0;
              let scale = 0.6;
              let zIndex = 1;

              // Calculate offset from the active card, handling circular array
              let offset = index - activeIndex;
              if (offset > services.length / 2) offset -= services.length;
              if (offset < -services.length / 2) offset += services.length;

              if (isMobile) {
                if (offset === 0) { // Only show the active card on mobile
                  positionX = 0;
                  opacity = 1;
                  scale = 1;
                  zIndex = 10;
                } else {
                  // For non-active cards on mobile, completely hide them
                  return null;
                }
              } else {
                // Existing desktop/tablet logic
                if (offset === 0) { // Center card
                  positionX = 0;
                  opacity = 0.9; // More transparent
                  scale = 1.2; // Larger scale
                  zIndex = 10;
                } else if (offset === 1) { // Right side card
                  positionX = baseCardWidth + cardGap;
                  opacity = 0.6; // More transparent
                  scale = 0.9; // Smaller scale
                  zIndex = 5;
                } else if (offset === -1) { // Left side card
                  positionX = -(baseCardWidth + cardGap);
                  opacity = 0.6; // More transparent
                  scale = 0.9; // Smaller scale
                  zIndex = 5;
                } else if (offset === 2) { // Far right card
                  positionX = 2 * (baseCardWidth + cardGap);
                  opacity = 0.3; // Even more transparent
                  scale = 0.8; // Even smaller scale
                  zIndex = 2;
                } else if (offset === -2) { // Far left card
                  positionX = -2 * (baseCardWidth + cardGap);
                  opacity = 0.3; // Even more transparent
                  scale = 0.8; // Even smaller scale
                  zIndex = 2;
                } else {
                  // Cards further away are hidden
                  opacity = 0;
                  scale = 0;
                  zIndex = 1;
                }
              }

              return (
                <div
                  key={index}
                  className={`absolute rounded-lg shadow-lg overflow-hidden transition-all duration-500 ease-in-out`}
                  style={{
                    width: `${baseCardWidth}px`,
                    height: `${baseCardHeight}px`,
                    transform: `translateX(${positionX}px) scale(${scale})`,
                    opacity: opacity,
                    zIndex: zIndex,
                    left: '50%',
                    marginLeft: `-${baseCardWidth / 2}px`,
                  }}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#364A9A] mb-2 font-poppins text-center">
                      {service.title}
                    </h3>
                    <p className="text-gray-700 text-center font-serif line-clamp-3">{service.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center mt-8 space-x-2">
          {services.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`block w-3 h-3 rounded-full transition-all duration-300
                ${index === activeIndex ? 'bg-[#364A9A] w-4 h-4' : 'bg-gray-300'}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;